module.exports = __webpack_public_path__ + "img/005.02027e04.jpg";